import React, {  useRef,useEffect, useState, useContext, useReducer, useCallback } from 'react';
import {useParams} from 'react-router-dom'
import history from "../history"

import { StaticRouter } from 'react-router';
import {LoginabodeContainerCom} from '../containers'
import {authenticateUsercredNowSVhook,authenticateUsercredNow,clearformUsercred,svlogoutAction} from '../redux/svractions/svusercreddetActions'
import {svauthNow} from "../actionspwa/svcosmoscreddetActions"
//import fscpageReducer from "../reducerspwa/fscpageReducer"
import fscpageReducer from "../reducerspwa/svcosmoscreddetReducer"
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';

import SVLoginabodeBody from '../components/accountsabode/accountcontainer/loginAbodeBody'
import {ProfilecosmosContainerCom} from '../containers'



const {noop} = StaticRouter
/*we are containerPage. we scall Facbybar pass him filters and the Com witl render as we send props to it */
//LoginabodeContainerCom

function LogincosmosContainerComPage() {
    console.log('SV*****LogincosmosContainerComPage')
    let { id } = useParams();
    let svparams = { 'id': id}
    let detInit = {
        "id": -1,
        "username": "alen@yahoo.com",
        "password": "Pete123"
       
    }

    let credInit = {
        loading: false,
        error: false,
        my_data_geo:{
            "countryTypes": [
                {
                    "name": "United STates America",
                    "a2": "US",
                    "a3": "USA",
                    "value": "USA",
                    "isonum": "840"
                },
                {
                    "name": "Canada",
                    "isdcode": "01",
                    "a2": "CA",
                    "a3": "CAN",
                    "value": "CAN",
                    "isonum": "124"
                }
            ],
            "stateTypes": [
                {
                    "name": "California",
                    "value": "CA",
                    "a2": "CA"
                },
                {
                    "name": "New York",
                    "value": "NY",
                    "a2": "NY"
                },
                {
                    "name": "Texas",
                    "value": "TX",
                    "a2": "TX"
                }
            ],
            "isdcodeTypes": [
                {
                    "name": "United States Of America(+1)",
                    "value": "1"
                },
                {
                    "name": "Australia(+61)",
                    "value": "61"
                },
                {
                    "name": "Spain(+34)",
                    "value": "34"
                }
            ],
            "genderTypes": [
                {
                    "name": "CL_MALE",
                    "value": "MALE"
                },
                {
                    "name": "CL_FEMALE",
                    "value": "FEMALE"
                }
            ]
        },
        my_data_usercreddet: {
            "id": -1,
            "username": "pet123@yahoo.com",
            "password": "pet123"
        },
        my_data_profile:{
            "id": -11,
            "username": "",
            "password": "",
            "addressId": -1,
            "customerId": -1,
            "name": "",
            "fname": "",
            "lname": "",
            "phone": "",
            "email": "",
            "login": "SVDEFAULT_NO_USER",
           
            "otherDetails": "",
            "city": "",
            "state": "",
            "country": "usa",
            "address": null,
            "zipcode": "",
            "isdcode": "1",
            "token":"ssDEFAULT",
            "MMtokenBAK": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzI0MjEwMjE4LCJleHAiOjE3MjQyMTM4MTh9.y29VFr0Ixli6xRJizR2-kqYvf5PEFMtxbM4s3WUJquc",
    
            "addressType": "B",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null
        }
       
    }
    
    const [det, setDet] = useState(detInit)
    const [{loading, error, my_data_geo,my_data_usercreddet,my_data_profile}, dispatch]= useReducer(fscpageReducer, credInit);
/*
    const getDinoCB = useCallback(() => {
        console.log('Step 2 - reactses useCall back fired');
        loadFscpageAction(dispatch);
    }, [dispatch]);
*/


//we get dispatcher

   const  svsubmitparent=(values)=>{
       
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
     
     
      let comCardAndTraveller = {
        usercredNew : values
       
      }  
      dispatch(authenticateUsercredNow(comCardAndTraveller))
    
    }
    const  clearformUsercreCB = useCallback(()=>{
        clearformUsercred(dispatch)
    },[dispatch])
    const  svsubmitparentCB = useCallback((values)=>{
        console.log('useCallback*****values')
        console.log(values)
        let comCardAndTraveller = {
            usercredNew : values
           
          }  
        svauthNow(dispatch,comCardAndTraveller)
       // authenticateUsercredNowSVhook(dispatch,values)
    },[dispatch])

    //authenticateUsercredNowSVhook
    const clearformUsercredDp = ()=>{
        dispatch(clearformUsercred())

    }

    const  userLogoutCB = useCallback(()=>{
        dispatch(svlogoutAction)
       // svlogoutAction(dispatch)
    },[dispatch])
    

   
    const getLoginBoardBody = (det,userLogout,svsubmitparent) =>{
        let perror = null
        if(perror){

            console.log('sv**container ger errob')
                       let errob = {
                           "timestamp": "2015-08-23T02:27:18.038+0000",
                           "status": 500,
                           "error": "FlyServer Error",
                           "message": "Username or Password is Incorrect and try again",
                           "path": "/kk/svaddressDetailPost"
                       }
                       let today_dt = new Date()
                       errob["timestamp"] = today_dt
                      return (
                        <div >
                           
                            <div style={{paddingTop:'10px'}}>
                                {/*  
                                <ErrorCom  closecbParent={closecbParent} errob={errob} ></ErrorCom>
                              
                                */}
                              <SVLoginabodeBody det={det} userLogout={userLogout}  svsubmitparent={svsubmitparent} ></SVLoginabodeBody>
                            </div>
                           
                           
                         </div>   
                           )
              
           }else{
   
               return (
                   <SVLoginabodeBody det={det} userLogout={userLogoutCB}  svsubmitparent={svsubmitparentCB} ></SVLoginabodeBody>
                                                          
               )
   
           }
    }
  
/*

    const getDinoCB = useCallback(() => {
        console.log('Step 2 - reactses useCall back fired');
        loadFscpageAction(dispatch);
    }, [dispatch]);
*/

    useEffect(() => {
        console.log('Step 1 - uses effect filter changes render container SVFlySearcComPage');
       // console.log(my_data_profile)
       
    }, [svparams]);

    console.log('SV******SVFlySearchComPage',svparams)
    let svdisplayLogin = "block"
    let svdet = null
   // let svparams = { 'id': -1}
    if (my_data_profile ) {
        svdet = my_data_profile
       
        let customerId = my_data_profile.customerId
        if(customerId >3){
            let redire_path = `/myaccountSV/${customerId}/svprofile`
            console.log(redire_path)
            svdisplayLogin = 'none'
            history.push(redire_path)
          //let svparams = { 'id': customerId}
          /*
          svparams['id'] = customerId
          return (
              <ProfilecosmosContainerCom svparams= {svparams} />
            );
            */
        }

       
        ///myaccountSV/:id/svprofile
      
      
    }
    console.log('%%%%%%%%START%%%%%%%%% this.props.my_data_profiled')
    console.log(svdet)
    console.log('%%%%%%%%%%%END%%%%%% this.props.my_data_profiled')
    
    return (
        <noop>
            {/* 
             <FlyTa></FlyTa>
              <FancySearchBar filters={filters}  ></FancySearchBar>
               <FancySearchBarFat filters={filters} setFilters={setFilters}  ></FancySearchBarFat>
            */}
           
            
           <div className="col-xs-12" >
                     
                   
                     <div  style={{"display":svdisplayLogin}}>
                         <span> <Icon  style={{ color:"#123456" , fontSize:"20px" }} type="audio" theme="filled" /></span>
                         {/*
                          <h1 style={{fontSize: "16px", color:'black',marginBottom:"30px"}}>fname:{det.fname}</h1>
                        
                         */}
                         {getLoginBoardBody(det,userLogoutCB,svsubmitparentCB)}
                    </div>
                    {/*  
                    <div  style={{"display":!svdisplayLogin}}>
                        <ProfilecosmosContainerCom svparams= {svparams} />
                    </div>
                     */}
            </div>
        </noop>
       
        
    );
}

export default LogincosmosContainerComPage